import {
    Callout,
    DefaultButton,
    DirectionalHint,
    IconButton,
    Persona,
    PersonaSize,
    Stack,
    Text
} from "@fluentui/react";
import React, { createRef, useContext, useState } from "react";
import { TimeZonePicker, Theme } from "sprint-common-web";

import { AuthContext } from "../../../../core/security/AuthProvider";
import { UserRole } from "../../../../core/security/User";
import { UserContext } from "../../../../core/security/UserProvider";

export const UserInfo: React.FunctionComponent = () => {
    const userContext = useContext(UserContext);
    const authContext = useContext(AuthContext);

    const [isCalloutVisible, setIsCalloutVisible] = useState(false);
    const divRef = createRef<HTMLDivElement>();

    const HandleLogout = (
        e: React.MouseEvent<HTMLDivElement | HTMLAnchorElement | HTMLButtonElement | HTMLSpanElement, MouseEvent>
    ) => {
        e.preventDefault();
        authContext.logout();
    };

    const onClickOpenCallout = () => {
        setIsCalloutVisible(!isCalloutVisible);
    };

    const onDismissCloseCallout = (): void => {
        setIsCalloutVisible(false);
    };

    return (
        <div ref={divRef} style={{ padding: 10, paddingRight: 20 }}>
            <IconButton
                onClick={onClickOpenCallout}
                styles={{
                    root: {
                        border: "0px",
                        height: 5,
                        width: 5,
                        padding: 5
                    }
                }}
                data-testid="user-info-badge"
            >
                <Persona text={userContext.name} hidePersonaDetails={true} size={PersonaSize.size32} />
            </IconButton>
            {isCalloutVisible && (
                <Callout
                    target={divRef}
                    directionalHint={DirectionalHint.bottomRightEdge}
                    onDismiss={onDismissCloseCallout}
                    data-testid="user-info-panel"
                >
                    <Stack>
                        <Stack>
                            <Stack horizontal={true} horizontalAlign="end">
                                <DefaultButton
                                    styles={{ root: { border: "0px", height: 50, width: 100 } }}
                                    onClick={HandleLogout}
                                >
                                    <Text>Sign out</Text>
                                </DefaultButton>
                            </Stack>
                        </Stack>
                        <Stack styles={{ root: { paddingBottom: 20, paddingLeft: 10 } }} horizontal={true}>
                            <Stack>
                                <Persona
                                    size={PersonaSize.size100}
                                    text={userContext.name}
                                    hidePersonaDetails={true}
                                    styles={{ root: { padding: 10 } }}
                                />
                            </Stack>
                            <Stack styles={{ root: { paddingRight: 30 } }}>
                                <Stack styles={{ root: { padding: 5 } }}>
                                    <Text
                                        styles={{ root: { fontSize: Theme.fonts.large.fontSize, fontWeight: "bold" } }}
                                    >
                                        {userContext.name}
                                    </Text>
                                </Stack>
                                <Stack styles={{ root: { padding: 5 } }}>
                                    <Text>{userContext.email}</Text>
                                </Stack>
                                <Stack styles={{ root: { padding: 5 } }}>
                                    <Text>
                                        Roles: {userContext.roles.map((role: UserRole) => role.toString()).join(", ")}
                                    </Text>
                                </Stack>
                                <Stack styles={{ root: { padding: 5 } }}>
                                    <TimeZonePicker />
                                </Stack>
                            </Stack>
                        </Stack>
                    </Stack>
                </Callout>
            )}
        </div>
    );
};
